import { render, staticRenderFns } from "./TabelaCancelarTrp.vue?vue&type=template&id=72d69dc2&scoped=true&"
import script from "./TabelaCancelarTrp.vue?vue&type=script&lang=js&"
export * from "./TabelaCancelarTrp.vue?vue&type=script&lang=js&"
import style0 from "./TabelaCancelarTrp.vue?vue&type=style&index=0&id=72d69dc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d69dc2",
  null
  
)

export default component.exports